import { messageStatusOption } from '@/utils/constant/const.js'
import { getOptionsItemLabel } from '@/utils/common'

export const contentTableConfig = {
  title: '',
  propList: [
    {
      prop: 'createdBy',
      label: 'profile.sender'
    },
    {
      prop: 'receiver',
      label: 'profile.receiver'
    },
    {
      prop: 'title',
      label: 'profile.title'
    },
    {
      prop: 'status',
      label: 'general.status',
      formatter: (row) => {
        return getOptionsItemLabel(row, messageStatusOption)
      }
    },
    {
      prop: 'createdTime',
      slotName: 'formatZeroTime',
      label: 'common.app-creation-time',
      width: 160
    },
    {
      label: 'common.app-operation',
      width: 200,
      slotName: 'handler'
    }
  ],
  showIndexColumn: true
}
